module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_19-bc3f576e3e82ec82a33766e075323b4e.jpg";